const name = 'circle-t';


const contents = `
<circle cx="31" cy="41" r="29"/>
<path fill="#FFF" d="M33.817 55h-5.634V31.469h-7.706v-4.64h21.046v4.64h-7.706z"/>
`;


/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'T',
};

export default icon;
